import { LinkField, RichTextField, Field, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  KeyValuePairItem,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C07PromoCTAProps = RenderingProps<
  {
    Headline?: Field<string>;
    TitleType?: KeyValuePairItem;
    Image?: ImageField;
    TitleIcon?: KeyValuePairItem;
    SupportingCopy?: RichTextField;
    FirstCTALink?: LinkField;
    SecondCTALink?: LinkField;
  },
  {
    BackgroundColor?: string;
    Layout?: string;
    TextAlignment?: string;
    ImageSide?: string;
    SecondCTAStyle?: string;
  } & DynamicPlaceholderParams &
    TranslationOptionsParams &
    AnchorTargetParams
>;
